import { render, staticRenderFns } from "./PricingDesktopEdu.vue?vue&type=template&id=5938aee8&scoped=true&"
import script from "./PricingDesktopEdu.vue?vue&type=script&lang=js&"
export * from "./PricingDesktopEdu.vue?vue&type=script&lang=js&"
import style0 from "./PricingDesktopEdu.vue?vue&type=style&index=0&id=5938aee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938aee8",
  null
  
)

export default component.exports